var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', _vm._l(_vm.subjects.filter(function (x) {
    return x.hidden == undefined || !x.hidden;
  }), function (subject, index) {
    return _c('div', {
      key: "field.".concat(index),
      staticClass: "field"
    }, [subject.type === 'text' ? [_c('SubjectLayout', {
      attrs: {
        "subject": subject,
        "validateError": _vm.v$.form["".concat(subject.id)].$error
      }
    }, [_vm.isPhoneVerificationField(subject) ? _c('PhoneVerification', {
      ref: "phoneVerification",
      refInFor: true,
      attrs: {
        "placeholder": _vm.displayPlaceholder(subject),
        "validation-error": _vm.v$.form["".concat(subject.id)].$error,
        "field-memo": subject.memo,
        "should-load-customer-data": subject.assign_to_customer_data === 'mobile_phone',
        "should-sync-customer-data": subject.save_to_customer_data === 'mobile_phone'
      },
      model: {
        value: _vm.form["".concat(subject.id)],
        callback: function callback($$v) {
          _vm.$set(_vm.form, "".concat(subject.id), $$v);
        },
        expression: "form[`${subject.id}`]"
      }
    }) : _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.form["".concat(subject.id)],
        expression: "form[`${subject.id}`]"
      }],
      staticClass: "field__input",
      class: {
        invalid: _vm.v$.form["".concat(subject.id)].$error
      },
      attrs: {
        "placeholder": _vm.displayPlaceholder(subject),
        "disabled": subject.disabled
      },
      domProps: {
        "value": _vm.form["".concat(subject.id)]
      },
      on: {
        "input": function input($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.form, "".concat(subject.id), $event.target.value);
        }
      }
    })], 1)] : _vm._e(), subject.type === 'textarea' ? [_c('SubjectLayout', {
      attrs: {
        "subject": subject,
        "validateError": _vm.v$.form["".concat(subject.id)].$error
      }
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.form["".concat(subject.id)],
        expression: "form[`${subject.id}`]"
      }],
      staticClass: "field__input",
      class: {
        invalid: _vm.v$.form["".concat(subject.id)].$error
      },
      attrs: {
        "placeholder": _vm.displayPlaceholder(subject),
        "disabled": subject.disabled,
        "rows": subject.rows
      },
      domProps: {
        "value": _vm.form["".concat(subject.id)]
      },
      on: {
        "input": function input($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.form, "".concat(subject.id), $event.target.value);
        }
      }
    })])] : _vm._e(), subject.type === 'select' ? [_c('SubjectLayout', {
      attrs: {
        "subject": subject,
        "validateError": _vm.v$.form["".concat(subject.id)].$error
      }
    }, [_c('SharedSelect', {
      class: {
        invalid: _vm.v$.form["".concat(subject.id)].$error
      },
      attrs: {
        "options": _vm.availableOptions(subject),
        "hasBorder": false,
        "placeholder": _vm.displayPlaceholder(subject),
        "disabled": subject.disabled
      },
      model: {
        value: _vm.form["".concat(subject.id)],
        callback: function callback($$v) {
          _vm.$set(_vm.form, "".concat(subject.id), $$v);
        },
        expression: "form[`${subject.id}`]"
      }
    })], 1)] : _vm._e(), subject.type === 'radio' ? [_c('SubjectLayout', {
      attrs: {
        "subject": subject,
        "validateError": _vm.v$.form["".concat(subject.id)].$error
      }
    }, [_c('div', {
      staticClass: "row"
    }, _vm._l(_vm.availableOptions(subject), function (option, optionIndex) {
      return _c('div', {
        key: index + '-' + optionIndex,
        staticClass: "col-12 col-sm-6 px-2"
      }, [_c('SharedRadioButton', {
        attrs: {
          "id": subject.id + '-' + optionIndex,
          "value": option.value,
          "name": subject.id,
          "disabled": subject.disabled
        },
        model: {
          value: _vm.form["".concat(subject.id)],
          callback: function callback($$v) {
            _vm.$set(_vm.form, "".concat(subject.id), $$v);
          },
          expression: "form[`${subject.id}`]"
        }
      }, [_vm._v(" " + _vm._s(option.text) + " ")])], 1);
    }), 0)])] : _vm._e(), subject.type === 'checkbox' ? [_c('SubjectLayout', {
      attrs: {
        "subject": subject,
        "validateError": _vm.v$.form["".concat(subject.id)].$error
      }
    }, [_c('div', {
      staticClass: "row"
    }, _vm._l(_vm.availableOptions(subject), function (option, optionIndex) {
      return _c('div', {
        key: index + '-' + optionIndex,
        staticClass: "col-12 col-sm-6 px-2"
      }, [_c('SharedCheckbox', {
        attrs: {
          "id": index + '-' + optionIndex,
          "value": option.value,
          "name": subject.id,
          "disabled": subject.disabled
        },
        model: {
          value: _vm.form["".concat(subject.id)],
          callback: function callback($$v) {
            _vm.$set(_vm.form, "".concat(subject.id), $$v);
          },
          expression: "form[`${subject.id}`]"
        }
      }, [_vm._v(" " + _vm._s(option.text) + " ")])], 1);
    }), 0)])] : _vm._e(), subject.type === 'datetime' ? [_c('SubjectLayout', {
      attrs: {
        "subject": subject,
        "validateError": _vm.v$.form["".concat(subject.id)].$error
      }
    }, [subject.format === 'datetime' ? [_c('DynamicFormDateTimePicker', {
      attrs: {
        "placeholder-for-date": _vm.displayPlaceholder(subject),
        "placeholder-for-time": _vm.displayPlaceholder(subject) || ' ',
        "has-error": _vm.v$.form["".concat(subject.id)].$error,
        "daily-time": subject.daily_time,
        "time-condition": subject.time_condition,
        "start-time": subject.start_time,
        "end-time": subject.end_time,
        "slot-minutes": subject.slot_minutes,
        "time-style": subject.time_style,
        "isLoading": _vm.branchFetching,
        "date-condition": subject.date_condition,
        "date-time-options": subject.options,
        "custom-time-options": subject.time_options,
        "disabled": subject.disabled,
        "optionDisabler": function optionDisabler(date, time) {
          return _vm.optionDisabler(subject, {
            date: date,
            time: time
          });
        }
      },
      on: {
        "input": function input(value) {
          return _vm.handleFieldValueChanged(value, subject);
        }
      },
      model: {
        value: _vm.form["".concat(subject.id)],
        callback: function callback($$v) {
          _vm.$set(_vm.form, "".concat(subject.id), $$v);
        },
        expression: "form[`${subject.id}`]"
      }
    })] : _vm._e(), subject.format === 'date' ? [_c('DynamicFormDatePicker', {
      attrs: {
        "placeholder": _vm.displayPlaceholder(subject),
        "has-error": _vm.v$.form["".concat(subject.id)].$error,
        "date-options": subject.options,
        "date-type": subject.date_condition,
        "isLoading": _vm.branchFetching,
        "disabled": subject.disabled
      },
      on: {
        "input": function input(value) {
          return _vm.handleFieldValueChanged(value, subject);
        }
      },
      model: {
        value: _vm.form["".concat(subject.id)],
        callback: function callback($$v) {
          _vm.$set(_vm.form, "".concat(subject.id), $$v);
        },
        expression: "form[`${subject.id}`]"
      }
    })] : _vm._e(), subject.format === 'time' ? [_c('DynamicFormTimePicker', {
      attrs: {
        "placeholder": _vm.displayPlaceholder(subject) || ' ',
        "has-error": _vm.v$.form["".concat(subject.id)].$error,
        "style-type": subject.time_condition,
        "start-time": subject.start_time,
        "end-time": subject.end_time,
        "slot-minutes": subject.slot_minutes,
        "time-style": subject.time_style,
        "isLoading": _vm.branchFetching,
        "disabled": subject.disabled,
        "custom-time-options": subject.time_options
      },
      on: {
        "input": function input(value) {
          return _vm.handleFieldValueChanged(value, subject);
        }
      },
      model: {
        value: _vm.form["".concat(subject.id)],
        callback: function callback($$v) {
          _vm.$set(_vm.form, "".concat(subject.id), $$v);
        },
        expression: "form[`${subject.id}`]"
      }
    })] : _vm._e()], 2)] : _vm._e(), subject.type === 'uploader' ? [_c('SubjectLayout', {
      attrs: {
        "subject": subject,
        "validateError": _vm.v$.form["".concat(subject.id)].$error
      }
    }, [_c('AppFileUploader', {
      attrs: {
        "has-error": _vm.v$.form["".concat(subject.id)].$error,
        "placeholder-when-uploaded": "（查看檔案）",
        "placeholder-when-empty": "",
        "showDeletedAction": !subject.disabled
      },
      on: {
        "uploading": _vm.handleFileUploading
      },
      model: {
        value: _vm.form["".concat(subject.id)],
        callback: function callback($$v) {
          _vm.$set(_vm.form, "".concat(subject.id), $$v);
        },
        expression: "form[`${subject.id}`]"
      }
    })], 1)] : _vm._e(), subject.type === 'collection_select' ? [_c('CollectionSelect', {
      ref: "collection-select-".concat(subject._id),
      refInFor: true,
      attrs: {
        "subject": subject,
        "branch-id": _vm.getBranchIdByFieldId(subject.branch_field_id),
        "is-related-to-branch": !!subject.branch_field_id,
        "optionDisabler": function optionDisabler(option) {
          return _vm.optionDisabler(subject, option);
        },
        "placeholder": _vm.displayPlaceholder(subject, '請選擇'),
        "validateError": _vm.v$.form["".concat(subject.id)].$error
      },
      on: {
        "input": function input(value) {
          return _vm.handleFieldValueChanged(value, subject);
        }
      },
      model: {
        value: _vm.form["".concat(subject.id)],
        callback: function callback($$v) {
          _vm.$set(_vm.form, "".concat(subject.id), $$v);
        },
        expression: "form[`${subject.id}`]"
      }
    })] : _vm._e(), subject.type === 'collection_carousel' ? [_c('SubjectLayout', {
      attrs: {
        "subject": subject,
        "validateError": _vm.v$.form["".concat(subject.id)].$error
      }
    }, [_c('CarouselSelection', {
      ref: "collection-carousel-".concat(subject._id),
      refInFor: true,
      attrs: {
        "placeholder": _vm.displayPlaceholder(subject, '請選擇'),
        "candidate-fetcher": function candidateFetcher() {
          return _vm.fetchCollectionItemsForCarousel(subject, subject.branch_field_id);
        },
        "disabled": false === _vm.carouselSelectionIsEnabled(subject) || subject.disabled,
        "value-matcher": _vm.matchCandidateForCollectionCarousel,
        "has-error": _vm.v$.form["".concat(subject.id)].$error
      },
      model: {
        value: _vm.form["".concat(subject.id)],
        callback: function callback($$v) {
          _vm.$set(_vm.form, "".concat(subject.id), $$v);
        },
        expression: "form[`${subject.id}`]"
      }
    })], 1)] : _vm._e(), subject.type === 'shop_selection' ? [_c('SubjectLayout', {
      attrs: {
        "subject": subject,
        "validateError": _vm.v$.form["".concat(subject.id)].$error
      }
    }, [_vm.deepGet(subject, 'branch_population', 'all') === 'all' ? _c('ShopSelection', {
      ref: "shop-selection-".concat(subject._id),
      refInFor: true,
      attrs: {
        "value": _vm.deepGet(_vm.form["".concat(subject.id)], 'value'),
        "branch-provider": subject.branch_provider || '',
        "show-branch-code": subject.show_branch_code || false,
        "placeholder": subject.default_select_text || '請選擇',
        "disabled": subject.disabled,
        "optionDisabler": function optionDisabler(option) {
          return _vm.optionDisabler(subject, option);
        }
      },
      on: {
        "selected": function selected(event) {
          return _vm.handleShopSelectionChange(event, subject);
        }
      }
    }) : _vm._e(), _vm.deepGet(subject, 'branch_population', 'all') === 'subset' ? _c('ShopSubsetSelection', {
      ref: "shop-subset-selection-".concat(subject._id),
      refInFor: true,
      attrs: {
        "value": _vm.deepGet(_vm.form["".concat(subject.id)], 'value'),
        "branch-ids": subject.branch_ids || '',
        "show-parent-branches": subject.show_parent_branch_options,
        "show-branch-code": subject.show_branch_code || false,
        "placeholder": subject.default_select_text || '請選擇',
        "disabled": subject.disabled
      },
      on: {
        "selected": function selected(event) {
          return _vm.handleShopSubsetSelectionChange(event, subject);
        }
      }
    }) : _vm._e()], 1)] : _vm._e()], 2);
  }), 0);
}
var staticRenderFns = []

export { render, staticRenderFns }